import React from "react";
import "./index.scss";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

class Receitas extends React.Component<{}> {
  render() {
    const receitas = [
      {
        title: "OSSOBUCO NA CERVEJA COM PURÊ DE MANDIOQUINHA",
        rendimento: "Rende de 3 a 4 porções.",
        ingredientes: [
          "1 kg de ossobuco ",
          "Pimenta-do-reino a gosto",
          "2 cubos de caldo de carne",
          "2 colheres de sopa de farinha de trigo",
          "1 colher de sopa de óleo",
          "2 tomates médios sem sementes, cortados em tiras",
          "1 folha de louro",
          "1/2 colher de chá de tomilho fresco",
          "2 xícaras de água fervente",
          "1 1/2 xícara de cerveja clara",
          "500 g de mandioquinha cozida e amassada",
          "4 colheres de sopa de leite",
          "1 xícara de queijo ralado grosso",
          "5 colheres de sopa de requeijão tipo Catupiry",
        ],
        preparo: [
          "Em uma tigela, coloque o ossobuco, tempere com pimenta a gosto e, em seguida, adicione a farinha de trigo e misture delicadamente. Reserve.",
          "Aqueça o óleo em uma panela de pressão e frite, em fogo médio, o ossobuco por 5 minutos ou até ficar levemente dourado.",
          "Junte os tomates, a folha de louro e o tomilho.",
          "Dissolva os cubos de caldo de carne na água fervente e acrescente ao refogado.",
          "Junte a cerveja, tampe a panela e cozinhe em fogo médio, por 30 minutos a partir do início da pressão.",
          "Apague o fogo, aguarde sair todo o vapor e verifique o cozimento. Se necessário, cozinhe mais um pouco. Reserve.",
          "Em uma tigela, coloque a mandioquinha, o leite e misture delicadamente.",
          "Junte os queijos e misture até ficar homogêneo.",
          "Em uma travessa, coloque o ossobuco reservado e o purê de mandioquinha.",
          "Sirva em seguida. ",
        ],
      },
      {
        title: "FILÉ MIGNON COM CEBOLAS AO VINHO",
        rendimento: "Rende 2 porções.",
        ingredientes: [
          "4 medalhões de mignon ",
          "4 cebolas em rodelas",
          "50 g de bacon picado",
          "4 ramos de salsinha picados",
          "4 colheres (sopa) de vinho tinto",
          "1 pitada de cravo-da-índia em pó",
          "2 colheres (sopa) de azeite de oliva",
          "2 colheres (chá) de pimenta-do-reino branca moída",
          "Sal a gosto",
          "1 xícara (chá) de batata palha",
        ],
        preparo: [
          "Reserve os medalhões. ",
          "Coloque em uma panela as cebolas e um pouco de sal. ",
          "Tampe a panela, leve ao fogo, sem mexer, por 7 minutos, ou até as cebolas ficarem bem macias. ",
          "Destampe a panela e cozinhe, por mais 5 minutos, ou até a cebola dourar e não reter mais líquido. ",
          "Junte a salsinha, o vinho, o cravo e o sal. ",
          "Cozinhe, mexendo de vez em quando, por mais 5 minutos. Retire do fogo e reserve. ",
          "Em uma frigideira, aqueça bem o azeite de oliva, adicione os medalhões e frite por 4 minutos, ou até dourar os dois lados. ",
          "Polvilhe o sal e a pimenta e retire do fogo. ",
          "Distribua a batata palha em 2 pratos.",
          "Coloque os medalhões e complete com as cebolas. ",
        ],
      },
      {
        title: "PEITO DE FRANGO CREMOSO",
        rendimento: "Rende 4 a 6 porções.",
        ingredientes: [
          "1 pacote de sopa creme de cebola",
          "1 lata de creme de leite",
          "2 colheres (sopa) de salsa picada",
          "2 peitos de frango com osso e sem pele",
        ],
        preparo: [
          "Em uma panela grande, dissolva o creme de cebola em 1 litro de água. ",
          "Coloque os peitos de frango, tampe e leve ao fogo até que estejam cozidos. ",
          "Retire o frango, descarte os ossos e desfie. ",
          "Junte a salsa e misture ao caldo que sobrou do cozimento. ",
          "Acrescente o creme de leite e mexa bem. ",
          "Despeje em um recipiente refratário e leve ao forno médio-alto (200°C), preaquecido, por cerca de 20 minutos ou até gratinar. ",
          "Sirva a seguir. ",
        ],
      },
      {
        title: "PERNIL SUÍNO AROMÁTICO",
        rendimento: "Rende até 12 porções.",
        ingredientes: [
          "½ pernil de porco (+/- 4 kg)",
          "Galhos de tomilho e alecrim",
          "½ xícara (chá) de mostarda (ou 5 colheres de sopa cheia)",
          "3 colheres (sopa) de alho picado (55 g)",
          "1 colher (sopa) de alecrim picado",
          "1 pimenta dedo-de-moça picada",
          "1 colher (sopa) de vinagre balsâmico",
          "1 kg de tomate maduro, sem sementes e picado em cubos pequenos",
          "1 cebola média picada em cubos pequenos (1 xícara de chá)",
          "¼ xícara (chá) de mel (ou 4 colheres de sopa)",
          "100 g de sal (ou 5 colheres de sopa)",
          "Pimenta-do-reino moída a gosto",
          "2 colheres (sopa) de amido de milho dissolvido em ¼ de xícara (chá) de água",
        ],
        preparo: [
          "Com a ponta de uma faca, faça furos em ½ pernil de porco (+/- 4 kg). Nos furos espete os galhos de tomilho e de alecrim. Reserve o pernil em uma assadeira. ",
          "Em uma tigela, misture ½ xícara (chá) de mostarda, 3 colheres (sopa) de alho picado, 1 colher (sopa) de alecrim picado, 1 pimenta dedo-de-moça picada, 1 colher (sopa) de vinagre balsâmico, 1 kg de tomate maduro, sem sementes e picado em cubos pequenos, 1 cebola média picada em cubos pequenos, ¼ xícara (chá) de mel, 100 g de sal, pimenta-do-reino moída a gosto e despeje sobre o pernil e deixe nesta marinada por 24 horas. ",
          "Depois deste tempo, cubra com papel alumínio e leve para assar em forno médio a 220 °C por 3 horas. ",
          "Tire o papel alumínio, com uma colher empurre para a assadeira todos os temperos que estiverem por cima do pernil (sem tirar os galhos de tomilho e alecrim) e volte-o ao forno por mais 1 hora ou até dourar. ",
          "Retire o pernil da assadeira e coloque sobre uma tábua. ",
          "Coloque a assadeira em fogo médio, acrescente 2 colheres (sopa) de amido de milho já dissolvido em ¼ de xícara (chá) de água e deixe engrossar por +/- 3 minutos. ",
          "Fatie o pernil e sirva com este molho. ",
        ],
      },
    ];
    return (
      <>
        <Header />
        <div className="container-textos">
          <h1 style={{ textAlign: "left", width: "100%" }}>
            CONFIRA AS RECEITAS DOMAKOSKI!
          </h1>
          <p>&nbsp;</p>
          <p style={{ textAlign: "justify", width: "100%" }}>
            Afinal, quando o assunto é um bom prato a ser servido e o objetivo é
            surpreender os convidados, a criatividade é sempre um ingrediente
            especial!
          </p>

          {receitas.map((receita) => (
            <>
              <hr
                style={{
                  width: "100%",
                  borderWidth: 1,
                  borderColor: "#CCCCCC",
                  borderStyle: "dotted",
                }}
              />
              <h3
                style={{
                  textAlign: "left",
                  width: "100%",
                  fontSize: "20px",
                  marginTop: 20,
                }}
              >
                {receita.title}
              </h3>
              <p
                style={{
                  textAlign: "justify",
                  width: "100%",
                  fontWeight: "bold",
                  marginTop: 20,
                }}
              >
                INGREDIENTES
              </p>
              <ul style={{ textAlign: "left", width: "100%" }}>
                {receita.ingredientes.map((ingrediente) => (
                  <li>{ingrediente}</li>
                ))}
              </ul>
              <p
                style={{
                  textAlign: "justify",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                PREPARO
              </p>
              <ul style={{ textAlign: "left", width: "100%" }}>
                {receita.preparo.map((passo) => (
                  <li>{passo}</li>
                ))}
              </ul>
              <p
                style={{
                  textAlign: "justify",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                {receita.rendimento}
              </p>
            </>
          ))}
        </div>
        <Footer />
      </>
    );
  }
}

export default Receitas;
